import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { Star, Phone, Mail, MapPin, Wrench, Droplets, Flame, Shield, Clock, CheckCircle, MessageCircle, Instagram, Upload, Zap } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
const Index = () => {
  const {
    toast
  } = useToast();
  const [selectedWhatsApp, setSelectedWhatsApp] = useState("+5491155251662");
  const [showReviewForm, setShowReviewForm] = useState(false);
  const [showGaleriaCompleta, setShowGaleriaCompleta] = useState(false);
  const [newReview, setNewReview] = useState({
    nombre: "",
    rating: 5,
    comentario: ""
  });
  const [reseñasActuales, setReseñasActuales] = useState([{
    nombre: "María González",
    rating: 5,
    comentario: "Excelente servicio, muy profesional y rápido. Solucionó el problema de gas en mi cocina de manera eficiente.",
    fecha: "Hace 2 semanas"
  }, {
    nombre: "Carlos Rodríguez",
    rating: 5,
    comentario: "Muy recomendable. Llegó puntual, trabajo limpio y precio justo. Ya es mi gasista de confianza.",
    fecha: "Hace 1 mes"
  }, {
    nombre: "Ana Martínez",
    rating: 5,
    comentario: "Profesional serio y responsable. Arregló la pérdida de agua en tiempo récord. Volveré a llamarlo sin dudas.",
    fecha: "Hace 3 semanas"
  }, {
    nombre: "Roberto Silva",
    rating: 5,
    comentario: "Excelente atención y conocimiento técnico. Me explicó todo el proceso y dejó todo impecable.",
    fecha: "Hace 1 semana"
  }]);
  const [formData, setFormData] = useState({
    nombre: "",
    telefono: "",
    email: "",
    direccion: "",
    servicio: "",
    descripcion: "",
    fotos: null as File[] | null
  });

  // Cargar reseñas del localStorage al iniciar
  useEffect(() => {
    const reseñasGuardadas = localStorage.getItem('inigaz-reseñas');
    if (reseñasGuardadas) {
      try {
        const reseñasParsed = JSON.parse(reseñasGuardadas);
        setReseñasActuales(reseñasParsed);
      } catch (error) {
        console.error('Error al cargar reseñas:', error);
      }
    }
  }, []);

  // Guardar reseñas en localStorage cada vez que cambien
  useEffect(() => {
    localStorage.setItem('inigaz-reseñas', JSON.stringify(reseñasActuales));
  }, [reseñasActuales]);
  const whatsappNumbers = [{
    number: "+5491155251662",
    label: "Principal",
    name: "Carlos Gasista"
  }, {
    number: "+5491135077955",
    label: "Secundario 1",
    name: "Facundo Gasista"
  }, {
    number: "+5491134253999",
    label: "Secundario 2",
    name: "Hector Electricista"
  }];
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Crear mensaje para WhatsApp
    let mensaje = `¡Hola! Solicito presupuesto para:
    
📋 *Datos del Cliente:*
• Nombre: ${formData.nombre}
• Teléfono: ${formData.telefono}
• Email: ${formData.email}
• Dirección: ${formData.direccion}

🔧 *Servicio Solicitado:*
${formData.servicio}

📝 *Descripción del Problema:*
${formData.descripcion}`;

    // Si hay fotos, agregar información sobre ellas
    if (formData.fotos && formData.fotos.length > 0) {
      mensaje += `\n\n📷 *Fotos adjuntas:* ${formData.fotos.length} imagen(es) - Las enviaré por separado`;
    }
    mensaje += `\n\n¡Gracias por su atención!`;
    const whatsappUrl = `https://wa.me/${selectedWhatsApp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(mensaje)}`;
    window.open(whatsappUrl, '_blank');

    // Si hay fotos, mostrar instrucciones
    if (formData.fotos && formData.fotos.length > 0) {
      toast({
        title: "Solicitud enviada",
        description: "Te redirigimos a WhatsApp. No olvides enviar las fotos que seleccionaste para completar tu solicitud.",
        duration: 6000
      });
    } else {
      toast({
        title: "Solicitud enviada",
        description: "Te redirigimos a WhatsApp para completar tu solicitud de presupuesto."
      });
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData({
        ...formData,
        fotos: Array.from(e.target.files)
      });
    }
  };
  const handleReviewSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Agregar la nueva reseña a la lista (en una aplicación real, esto se guardaría en una base de datos)
    const nuevaReseña = {
      ...newReview,
      fecha: "Recién agregada"
    };

    // Agregar la reseña inmediatamente a la lista
    setReseñasActuales([nuevaReseña, ...reseñasActuales]);

    // Crear mensaje de notificación para WhatsApp
    const mensajeNotificacion = `🌟 *NUEVA RESEÑA RECIBIDA* 🌟

👤 *Cliente:* ${newReview.nombre}
⭐ *Calificación:* ${newReview.rating}/5 estrellas
💬 *Comentario:* "${newReview.comentario}"

📅 *Fecha:* ${new Date().toLocaleDateString('es-AR')}

¡Un cliente más satisfecho con nuestros servicios!`;

    // Enviar notificación a todos los números de WhatsApp
    whatsappNumbers.forEach((wp, index) => {
      setTimeout(() => {
        const whatsappUrl = `https://wa.me/${wp.number.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(mensajeNotificacion)}`;
        window.open(whatsappUrl, '_blank');
      }, index * 1000); // Delay de 1 segundo entre cada envío
    });

    // Mostrar confirmación
    toast({
      title: "¡Reseña agregada!",
      description: "Tu reseña ya está visible en la página y hemos notificado al equipo. ¡Gracias por tu comentario!",
      duration: 5000
    });

    // Limpiar el formulario
    setNewReview({
      nombre: "",
      rating: 5,
      comentario: ""
    });
    setShowReviewForm(false);
  };
  const servicios = [{
    icon: <Flame className="h-8 w-8" />,
    title: "Instalación de Gas",
    description: "Instalación y reparación de sistemas de gas domiciliarios e industriales",
    features: ["Conexiones nuevas", "Reparación de fugas", "Certificaciones"]
  }, {
    icon: <Droplets className="h-8 w-8" />,
    title: "Plomería General",
    description: "Servicios completos de plomería para hogar y empresa",
    features: ["Destapaciones", "Reparación de cañerías", "Instalación de sanitarios"]
  }, {
    icon: <Zap className="h-8 w-8" />,
    title: "Electricidad",
    description: "Instalaciones eléctricas y reparaciones profesionales",
    features: ["Instalaciones nuevas", "Reparación de cortocircuitos", "Tableros eléctricos"]
  }, {
    icon: <Wrench className="h-8 w-8" />,
    title: "Mantenimiento",
    description: "Mantenimiento preventivo y correctivo de instalaciones",
    features: ["Revisiones periódicas", "Limpieza de CISTERNAS", "Cambio de repuestos"]
  }, {
    icon: <Shield className="h-8 w-8" />,
    title: "Certificaciones",
    description: "Certificaciones oficiales y habilitaciones",
    features: ["Certificado de gas", "Habilitaciones municipales", "Inspecciones técnicas"]
  }];
  const trabajosRealizados = [{
    imagen: "./images/IMG-20251010-WA0007.jpg",
    titulo: "Trabajo de Plomería Profesional"
  }, {
    imagen: "./images/IMG-20251010-WA0008.jpg",
    titulo: "Servicio de Gas Especializado"
  }, {
    imagen: "./images/IMG-20251010-WA0009.jpg",
    titulo: "Instalación Eléctrica Completa"
  }, {
    imagen: "./images/IMG-20251010-WA0010.jpg",
    titulo: "Proyecto Integral Completado"
  }, {
    imagen: "./images/IMG-20251010-WA0011.jpg",
    titulo: "Mantenimiento y Reparaciones"
  }];

  const galeriaCompleta = [
    "./images/IMG-20251029-WA0099.jpg",
    "./images/IMG-20251029-WA0096.jpg",
    "./images/IMG-20251029-WA0094.jpg",
    "./images/IMG-20251029-WA0076.jpg",
    "./images/IMG-20251029-WA0090.jpg",
    "./images/IMG-20251029-WA0092.jpg",
    "./images/IMG-20251029-WA0062.jpg",
    "./images/IMG-20251029-WA0061.jpg",
    "./images/IMG-20251029-WA0041.jpg",
    "./images/IMG-20251029-WA0037.jpg",
    "./images/IMG-20251029-WA0058.jpg",
    "./images/IMG-20251029-WA0005.jpg",
    "./images/IMG-20251029-WA0002.jpg",
    "./images/IMG-20251029-WA0020.jpg",
    "./images/IMG-20251029-WA0028.jpg",
    "./images/IMG-20251029-WA0002 1.jpg"
  ];
  return <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-secondary shadow-sm border-b border-primary">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="bg-primary p-2 rounded-md animate-pulse-slow">
                <Wrench className="h-6 w-6 text-black hover:scale-110 transition-transform duration-300" />
              </div>
              <div>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary hover:scale-105 transition-transform duration-300">Iñigaz e Hijos</h1>
                <p className="text-sm md:text-base text-primary/80">Plomería, Gas y Electricidad</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <Select value={selectedWhatsApp} onValueChange={setSelectedWhatsApp}>
                <SelectTrigger className="w-48 bg-primary text-black border-primary hover:bg-accent hover:text-white transition-all duration-300">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {whatsappNumbers.map(wp => <SelectItem key={wp.number} value={wp.number}>
                      {wp.name}
                    </SelectItem>)}
                </SelectContent>
              </Select>
              <Button onClick={() => window.open(`https://wa.me/${selectedWhatsApp.replace(/[^0-9]/g, '')}`, '_blank')} className="btn-gradient animate-bounce-slow">
                <MessageCircle className="h-4 w-4 mr-2" />
                WhatsApp
              </Button>
              <Button variant="outline" onClick={() => window.open('https://www.instagram.com/ini_gazehijos', '_blank')} className="btn-accent">
                <Instagram className="h-4 w-4 mr-2" />
                Instagram
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-bg py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent"></div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 animate-float">
              Servicios Profesionales de 
              <span className="text-primary block animate-pulse-slow">Plomería, Gas y Electricidad</span>
            </h2>
            <p className="text-xl text-gray-200 mb-8 hover:text-white transition-colors duration-300">
              Empresa familiar con más de 20 años de experiencia. 
              Servicios de calidad, rápidos y confiables.
            </p>
            <div className="flex flex-wrap justify-center gap-3 mb-8">
              <Badge variant="secondary" className="bg-primary/90 text-black border-primary hover:scale-105 transition-transform duration-300 animate-bounce-slow">
                <Clock className="h-4 w-4 mr-1" />
                Servicio 24/7
              </Badge>
              <Badge variant="secondary" className="bg-accent/90 text-white border-accent hover:scale-105 transition-transform duration-300">
                <Shield className="h-4 w-4 mr-1" />
                Matriculado
              </Badge>
              <Badge variant="secondary" className="bg-primary/90 text-black border-primary hover:scale-105 transition-transform duration-300">
                <CheckCircle className="h-4 w-4 mr-1" />
                Garantía
              </Badge>
            </div>
            <Button size="lg" className="btn-gradient text-lg px-8 py-4 hover:shadow-2xl animate-pulse-slow" onClick={() => document.getElementById('presupuesto')?.scrollIntoView({
            behavior: 'smooth'
          })}>
              <CheckCircle className="h-5 w-5 mr-2" />
              Solicitar Presupuesto Gratis
            </Button>
          </div>
        </div>
      </section>

      {/* Servicios */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-3">Nuestros Servicios</h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Ofrecemos una amplia gama de servicios profesionales para satisfacer todas tus necesidades
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
            {servicios.map((servicio, index) => <Card key={index} className="card-modern hover:border-accent/30 transition-all duration-300 group">
                <CardHeader className="text-center pb-4">
                  <div className={`p-3 rounded-md w-fit mx-auto text-black mb-3 group-hover:scale-110 transition-transform duration-300 animate-float ${index === 2 ? 'bg-accent text-white' : 'bg-primary'}`}>
                    {servicio.icon}
                  </div>
                  <CardTitle className="text-lg group-hover:text-primary transition-colors duration-300">{servicio.title}</CardTitle>
                  <CardDescription className="text-sm group-hover:text-gray-700 transition-colors duration-300">{servicio.description}</CardDescription>
                </CardHeader>
                <CardContent className="pt-0">
                  <ul className="space-y-1">
                    {servicio.features.map((feature, idx) => <li key={idx} className="flex items-center text-sm text-gray-600 hover:text-gray-800 transition-colors duration-300">
                        <CheckCircle className="h-3 w-3 text-green-500 mr-2 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                        {feature}
                      </li>)}
                  </ul>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Galería de Trabajos */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-3">Trabajos Realizados</h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Algunos ejemplos de nuestros trabajos más recientes
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {trabajosRealizados.map((trabajo, index) => <Card key={index} className="card-modern hover:border-accent/50 transition-all duration-300 group overflow-hidden">
                <div className="relative overflow-hidden">
                  <img src={trabajo.imagen} alt={trabajo.titulo} className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300" />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300"></div>
                </div>
                <CardContent className="p-4 text-center">
                  
                </CardContent>
              </Card>)}
          </div>
          
          {/* Botón CONOCENOS */}
          <div className="text-center mt-12">
            <Button 
              size="lg"
              className="btn-gradient text-lg px-8 py-4 hover:shadow-2xl animate-pulse-slow"
              onClick={() => setShowGaleriaCompleta(!showGaleriaCompleta)}
            >
              <CheckCircle className="h-5 w-5 mr-2" />
              {showGaleriaCompleta ? "OCULTAR GALERÍA" : "CONOCENOS"}
            </Button>
          </div>
          
          {/* Galería Completa */}
          {showGaleriaCompleta && (
            <div className="mt-12">
              <h4 className="text-2xl font-bold text-center text-gray-900 mb-8">Galería Completa de Trabajos</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {galeriaCompleta.map((imagen, index) => (
                  <div key={index} className="group overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300">
                    <img 
                      src={imagen} 
                      alt={`Trabajo ${index + 1}`}
                      className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Reseñas */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-3">Lo que Dicen Nuestros Clientes</h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              La satisfacción de nuestros clientes es nuestra mejor carta de presentación
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {reseñasActuales.map((reseña, index) => <Card key={index} className="card-modern">
                <CardContent className="p-5">
                  <div className="flex items-center mb-3">
                    {[...Array(reseña.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}
                  </div>
                  <p className="text-sm mb-3 text-gray-700 italic">"{reseña.comentario}"</p>
                  <div className="border-t pt-3">
                    <p className="font-medium text-sm">{reseña.nombre}</p>
                    <p className="text-xs text-gray-500">{reseña.fecha}</p>
                  </div>
                </CardContent>
              </Card>)}
          </div>
          
          {/* Botón para agregar reseña */}
          <div className="text-center mt-8">
            <Button onClick={() => setShowReviewForm(!showReviewForm)} className="btn-gradient">
              {showReviewForm ? "Cancelar" : "Agregar mi Reseña"}
            </Button>
          </div>

          {/* Formulario para nueva reseña */}
          {showReviewForm && <div className="max-w-md mx-auto mt-8">
              <Card className="card-modern">
                <CardContent className="p-6">
                  <h4 className="font-medium mb-4 text-center">Comparte tu Experiencia</h4>
                  <form onSubmit={handleReviewSubmit} className="space-y-4">
                    <div>
                      <Label htmlFor="review-nombre">Tu Nombre</Label>
                      <Input id="review-nombre" value={newReview.nombre} onChange={e => setNewReview({
                    ...newReview,
                    nombre: e.target.value
                  })} required />
                    </div>
                    
                    <div>
                      <Label htmlFor="review-rating">Calificación</Label>
                      <Select value={newReview.rating.toString()} onValueChange={value => setNewReview({
                    ...newReview,
                    rating: parseInt(value)
                  })}>
                        <SelectTrigger>
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="5">⭐⭐⭐⭐⭐ Excelente</SelectItem>
                          <SelectItem value="4">⭐⭐⭐⭐ Muy Bueno</SelectItem>
                          <SelectItem value="3">⭐⭐⭐ Bueno</SelectItem>
                          <SelectItem value="2">⭐⭐ Regular</SelectItem>
                          <SelectItem value="1">⭐ Malo</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>

                    <div>
                      <Label htmlFor="review-comentario">Tu Comentario</Label>
                      <Textarea id="review-comentario" value={newReview.comentario} onChange={e => setNewReview({
                    ...newReview,
                    comentario: e.target.value
                  })} placeholder="Cuéntanos sobre tu experiencia con nuestros servicios..." rows={3} required />
                    </div>

                    <Button type="submit" className="w-full btn-gradient">
                      Enviar Reseña
                    </Button>
                  </form>
                </CardContent>
              </Card>
            </div>}
        </div>
      </section>
      {/* Formulario de Presupuesto */}
      <section id="presupuesto" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-10">
              <h3 className="text-3xl font-bold text-gray-900 mb-3">Solicitar Presupuesto</h3>
              <p className="text-gray-600">
                Completa el formulario y te contactaremos a la brevedad
              </p>
            </div>
            <Card className="card-modern">
              <CardContent className="p-6">
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="nombre">Nombre y Apellido *</Label>
                      <Input id="nombre" value={formData.nombre} onChange={e => setFormData({
                      ...formData,
                      nombre: e.target.value
                    })} required />
                    </div>
                    <div>
                      <Label htmlFor="telefono">Teléfono *</Label>
                      <Input id="telefono" type="tel" value={formData.telefono} onChange={e => setFormData({
                      ...formData,
                      telefono: e.target.value
                    })} required />
                    </div>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="email">Email *</Label>
                      <Input id="email" type="email" value={formData.email} onChange={e => setFormData({
                      ...formData,
                      email: e.target.value
                    })} required />
                    </div>
                    <div>
                      <Label htmlFor="direccion">Dirección</Label>
                      <Input id="direccion" value={formData.direccion} onChange={e => setFormData({
                      ...formData,
                      direccion: e.target.value
                    })} />
                    </div>
                  </div>

                  <div>
                    <Label htmlFor="servicio">Tipo de Servicio *</Label>
                    <Select value={formData.servicio} onValueChange={value => setFormData({
                    ...formData,
                    servicio: value
                  })}>
                      <SelectTrigger>
                        <SelectValue placeholder="Selecciona el tipo de servicio" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="instalacion-gas">Instalación de Gas</SelectItem>
                        <SelectItem value="reparacion-gas">Reparación de Gas</SelectItem>
                        <SelectItem value="plomeria-general">Plomería General</SelectItem>
                        <SelectItem value="destapaciones">Destapaciones</SelectItem>
                        <SelectItem value="electricidad">Electricidad</SelectItem>
                        <SelectItem value="instalacion-electrica">Instalación Eléctrica</SelectItem>
                        <SelectItem value="mantenimiento">Mantenimiento</SelectItem>
                        <SelectItem value="certificaciones">Certificaciones</SelectItem>
                        <SelectItem value="emergencia">Emergencia</SelectItem>
                        <SelectItem value="otro">Otro</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>

                  <div>
                    <Label htmlFor="descripcion">Descripción del Problema *</Label>
                    <Textarea id="descripcion" value={formData.descripcion} onChange={e => setFormData({
                    ...formData,
                    descripcion: e.target.value
                  })} placeholder="Describe detalladamente el problema o servicio que necesitas..." rows={4} required />
                  </div>

                  <div>
                    
                    <div className="mt-2">
                      <Input id="fotos" type="file" multiple accept="image/*" onChange={handleFileChange} className="hidden" />
                      
                    </div>
                  </div>

                  <Button type="submit" className="w-full btn-gradient py-3">
                    <MessageCircle className="h-4 w-4 mr-2" />
                    Enviar Solicitud por WhatsApp
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Contacto */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-3">Contacto</h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Estamos disponibles para atenderte cuando nos necesites
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <Card className="card-modern text-center">
              <CardContent className="p-6">
                <div className="bg-primary p-3 rounded-md w-fit mx-auto mb-4">
                  <Phone className="h-6 w-6 text-black" />
                </div>
                <h4 className="font-medium mb-2">Teléfonos</h4>
                <p className="text-gray-600 mb-4 text-sm">Llamanos o envianos un WhatsApp</p>
                <div className="space-y-2">
                  {whatsappNumbers.map((wp, index) => <Button key={wp.number} variant="outline" onClick={() => window.open(`https://wa.me/${wp.number.replace(/[^0-9]/g, '')}`, '_blank')} className="w-full text-sm flex flex-col py-3 h-auto">
                      <span className="font-medium">{wp.name}</span>
                      <span className="text-xs text-gray-500">{wp.number}</span>
                    </Button>)}
                </div>
              </CardContent>
            </Card>

            <Card className="card-modern text-center">
              <CardContent className="p-6">
                <div className="bg-primary p-3 rounded-md w-fit mx-auto mb-4">
                  <Instagram className="h-6 w-6 text-black" />
                </div>
                <h4 className="font-medium mb-2">Instagram</h4>
                <p className="text-gray-600 mb-4 text-sm">Seguinos para ver nuestros trabajos</p>
                <Button variant="outline" onClick={() => window.open('https://www.instagram.com/ini_gazehijos', '_blank')} className="w-full">
                  @ini_gazehijos
                </Button>
              </CardContent>
            </Card>

            <Card className="card-modern text-center">
              <CardContent className="p-6">
                <div className="bg-primary p-3 rounded-md w-fit mx-auto mb-4">
                  <Clock className="h-6 w-6 text-black" />
                </div>
                <h4 className="font-medium mb-2">Horarios</h4>
                <p className="text-gray-600 mb-4 text-sm">Disponibilidad de servicio</p>
                <div className="text-sm space-y-1">
                  <p><strong>Lun - Vie:</strong> 8:00 - 18:00</p>
                  <p><strong>Sáb:</strong> 8:00 - 14:00</p>
                  <p><strong>Emergencias:</strong> 24/7</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-secondary text-primary py-10">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <div className="bg-primary p-2 rounded-md animate-pulse-slow">
                <Wrench className="h-5 w-5 text-black hover:scale-110 transition-transform duration-300" />
              </div>
              <h4 className="text-2xl md:text-3xl font-bold hover:scale-105 transition-transform duration-300">Iñigaz e Hijos</h4>
            </div>
            <p className="text-primary/80 mb-6">
              Plomería, Gas y Electricidad - Servicios Profesionales de Calidad
            </p>
            <div className="flex justify-center space-x-4">
              <Button variant="ghost" size="sm" onClick={() => window.open('https://wa.me/5491155251662', '_blank')} className="text-gray-300 hover:text-white">
                <MessageCircle className="h-4 w-4 mr-2" />
                WhatsApp
              </Button>
              <Button variant="ghost" size="sm" onClick={() => window.open('https://www.instagram.com/ini_gazehijos', '_blank')} className="text-gray-400 hover:text-white">
                <Instagram className="h-4 w-4 mr-2" />
                Instagram
              </Button>
            </div>
            <div className="border-t border-primary/20 mt-8 pt-8">
              <p className="text-sm text-primary/60">
                © 2024 Iñigaz e Hijos. Todos los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
};
export default Index;